export const APP_STORE_URL = 'https://apps.apple.com/de/app/gazetefutbol-app/id6783958084?l=en-GB';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=de.gazetefutbol.app';

export const projects = [
  {
    slug: 'gazetefutbol-app',
    title: 'GazeteFutbol App',
    category: 'App',
    status: 'Released',
    statusVariant: 'released',
    description:
      'German-language news and community app for Turkish football: Süper Lig coverage, club feeds, stories, chat, and filtered push.',
    hardPart:
      'WordPress credentials stay on the server. The app only talks through a proxied API with App Check.',
    stack: ['Ionic React', 'Capacitor 6', 'Firebase', 'WordPress'],
    tech: [
      'Ionic React',
      'Capacitor 6',
      'TypeScript',
      'WordPress REST',
      'Firebase',
      'Cloud Functions',
      'AdMob Native',
      'FCM',
    ],
    body:
      'iOS/Android app for GazeteFutbol. News, tables, stories, comments, chat, favorite-club feed and filtered push. Ionic React in Capacitor; WordPress for content (proxied so credentials stay off-device); Firebase for chat, FCM, Remote Config and App Check.',
    icon: '/projects/gazetefutbol/icon.jpg',
    screenshots: [
      '/projects/gazetefutbol/screen-1.jpg',
      '/projects/gazetefutbol/screen-2.jpg',
      '/projects/gazetefutbol/screen-3.jpg',
      '/projects/gazetefutbol/screen-4.jpg',
      '/projects/gazetefutbol/screen-5.jpg',
    ],
    links: [
      { label: 'App Store', href: APP_STORE_URL, icon: 'apple' },
      { label: 'Google Play', href: PLAY_STORE_URL, icon: 'android' },
    ],
    metaDescription:
      'GazeteFutbol App: Ionic/Capacitor news app for Turkish football. WordPress + Firebase, AdMob Native, App Store and Google Play.',
  },
  {
    slug: 'wordpress-social-poster',
    title: 'Gazete Social Poster',
    subtitle: 'In-house WordPress plugin for GazeteFutbol and GazeteGurbet.',
    category: 'Plugin',
    status: 'Released',
    statusVariant: 'released',
    description:
      'Turns published articles into branded Facebook, Instagram, and Threads posts: feed cards, stories, captions, and a queue that doesn’t block editors.',
    hardPart:
      'Publishing is queued on WP-Cron so editors never wait on Meta API calls.',
    stack: ['PHP', 'WordPress', 'Facebook Graph API', 'Instagram Graph API', 'Threads API'],
    tech: [
      'PHP 8.2',
      'WordPress',
      'Custom job queue',
      'WP-Cron',
      'Facebook Graph API',
      'Instagram Graph API',
      'Threads API',
      'Imagick / GD',
      'DeepSeek',
    ],
    body:
      'WordPress plugin that publishes GazeteFutbol and GazeteGurbet articles to Facebook, Instagram and Threads. Builds branded feed cards and 9:16 story frames (Imagick, GD fallback), then queues channel-specific jobs via WP-Cron.',
    metaDescription:
      'Gazete Social Poster: WordPress plugin for branded Facebook, Instagram and Threads posts with a job queue.',
  },
  {
    slug: 'swipetrim',
    title: 'SwipeTrim',
    category: 'App',
    status: 'In development',
    statusVariant: 'dev',
    description:
      'Swipe through your photo library to keep or delete, plus image compression with adjustable levels.',
    hardPart:
      'PhotoKit delete flow with undo before anything is actually removed.',
    stack: ['SwiftUI', 'PhotoKit', 'iOS 17+'],
    tech: ['SwiftUI', 'PhotoKit', 'iOS 17+', 'On-device only'],
    body:
      'Native iOS app (SwiftUI, iOS 17+) for photo and video library cleanup. Swipe to keep or queue for trash, undo, then review and delete via PhotoKit. Also compresses images: set a compression level, run auto or manual compress, and choose whether to delete the original or keep it. On-device only; no App Store build yet.',
    metaDescription:
      'SwipeTrim: native iOS app for photo library cleanup and image compression with PhotoKit.',
  },
  {
    slug: 'the-hoarders-vault',
    title: "The Hoarder's Vault",
    category: 'App',
    status: 'In development',
    statusVariant: 'dev',
    description:
      'Trading card inventory on iPhone. Scan Magic, Pokémon, and One Piece cards or add them by hand.',
    hardPart:
      'Card scanning and matching stay on the device. No account required.',
    stack: ['SwiftUI', 'iOS 17+'],
    body:
      "The Hoarder's Vault keeps your trading card collection on iPhone. Scan Magic, Pokémon, and One Piece cards or add them by hand.",
    metaDescription:
      "The Hoarder's Vault: trading card inventory on iPhone. Scan Magic, Pokémon, and One Piece cards.",
  },
];

export function getProjectBySlug(slug) {
  return projects.find((project) => project.slug === slug);
}

export function getReleasedProjects() {
  return projects.filter((project) => project.statusVariant === 'released');
}

export function getInProgressProjects() {
  return projects.filter((project) => project.statusVariant !== 'released');
}
